import { useEffect, useState } from "react";
import { collection } from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig";
import { EMERGENCIES } from "../shared/emergencyData";
import { resilientOnSnapshot } from "../shared/resilientSnapshot";

// Live map of studentId -> check-in record for an emergency. Real-time, so a homeroom
// teacher sees their student flip to "accounted for by someone else" the instant it
// happens. Resilient: a stale-token blip self-heals (force token refresh + re-subscribe)
// rather than permanently killing the accountability listener.
export default function useEmergencyCheckIns(emergencyId) {
  const [checkIns, setCheckIns] = useState({}); // studentId -> record

  useEffect(() => {
    if (!emergencyId) { setCheckIns({}); return; }
    return resilientOnSnapshot(
      collection(firestore, EMERGENCIES, emergencyId, "checkIns"),
      snap => {
        const map = {};
        snap.docs.forEach(d => { map[d.id] = { id: d.id, ...d.data() }; });
        setCheckIns(map);
      },
      "useEmergencyCheckIns",
    );
  }, [emergencyId]);

  return checkIns;
}
